import { kioskApi } from '../axios.js';
/**
 * Upload a selfie image to S3
 * @param formData FormData containing image and metadata
 * @returns Upload result with URL and expiration
 */
export const uploadSelfie = async (formData) => {
    const response = await kioskApi.post('/mbti/upload-selfie', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};
/**
 * Process a video from Travel 3 API
 * @param videoUrl Temporary video URL from Travel 3 API
 * @param metadata Metadata for the video
 * @returns Processing result with permanent S3 URL
 */
export const processVideo = async (videoUrl, metadata) => {
    const response = await kioskApi.post('/mbti/process-video', {
        videoUrl,
        metadata
    });
    return response.data;
};
/**
 * Save media metadata
 * @param metadata Media metadata
 * @returns Saved media record
 */
export const saveMediaMetadata = async (metadata) => {
    const response = await kioskApi.post('/mbti/media-metadata', metadata);
    return response.data;
};
/**
 * Get media records for photowall
 * @param shopId Shop ID
 * @param limit Maximum number of records to return
 * @returns Media records for photowall
 */
export const getPhotowallMedia = async (shopId, limit = 20) => {
    const response = await kioskApi.get(`/mbti/photowall?shopId=${shopId}&limit=${limit}`);
    return response.data;
};
/**
 * Toggle photowall visibility for a media item
 * @param id Media record ID
 * @returns Updated media record
 */
export const togglePhotowallVisibility = async (id) => {
    const response = await kioskApi.patch(`/mbti/photowall/${id}/toggle`);
    return response.data;
};
/**
 * Get photowall statistics
 * @param shopId - Shop ID
 * @returns Photowall statistics
 */
export const getPhotowallStats = async (shopId) => {
    const { data } = await kioskApi.get(`/mbti/photowall/stats?shopId=${shopId}`);
    return data;
};
/**
 * Download all photowall media as ZIP file
 * @param shopId - Shop ID
 * @param instanceId - Optional instance ID for specific instance
 * @returns ZIP file download
 */
export const downloadPhotowall = async (shopId, instanceId) => {
    const url = `/mbti/photowall/download?shopId=${shopId}${instanceId ? `&instanceId=${instanceId}` : ''}`;
    const response = await kioskApi.get(url, { responseType: 'blob' });
    return response;
};
/**
 * Clear all photowall media and linked selfies
 * @param shopId - Shop ID
 * @param instanceId - Optional instance ID for specific instance
 * @returns Clear operation result
 */
export const clearPhotowall = async (shopId, instanceId) => {
    const url = `/mbti/photowall/clear?shopId=${shopId}${instanceId ? `&instanceId=${instanceId}` : ''}`;
    const { data } = await kioskApi.delete(url);
    return data;
};
/**
 * List all media records for a shop
 * @param shopId The shop ID
 */
export const listMBTIMedia = async (shopId) => {
    const response = await kioskApi.get(`/mbti/media-metadata?shopId=${shopId}`);
    return response.data;
};
/**
 * Delete a media record by its ID
 * @param id The ID of the media record to delete
 */
export const deleteMBTIMedia = async (id) => {
    await kioskApi.delete(`/mbti/media-metadata/${id}`);
};
